import type {
  PersonalSurveyProfile,
  PersonalSurveyProfileInput,
  PersonalSurveyProfileTrackingCategory,
} from '@/types';

export const toPersonalSurveyProfileInput = (
  profile: PersonalSurveyProfile,
): PersonalSurveyProfileInput => ({
  department: profile.department ?? '',
  market_area: profile.market_area ?? '',
  technology_area: profile.technology_area ?? '',
  technical_challenge: profile.technical_challenge ?? '',
  additional_business_context: profile.additional_business_context ?? '',
});

const BUSINESS_INFO_KEYS = [
  'department',
  'market_area',
  'technology_area',
  'technical_challenge',
] as const satisfies readonly (keyof PersonalSurveyProfileInput)[];

const PROFILE_INPUT_KEYS = [
  ...BUSINESS_INFO_KEYS,
  'additional_business_context',
] as const satisfies readonly (keyof PersonalSurveyProfileInput)[];

export const hasBusinessInfo = (input: PersonalSurveyProfileInput): boolean =>
  BUSINESS_INFO_KEYS.some(key => input[key].trim().length > 0);

export const isSameProfileInput = (
  a: PersonalSurveyProfileInput,
  b: PersonalSurveyProfileInput,
): boolean =>
  PROFILE_INPUT_KEYS.every(
    key => (a[key] ?? '').trim() === (b[key] ?? '').trim(),
  );

export const isSameBusinessInfo = (
  a: PersonalSurveyProfileInput,
  b: PersonalSurveyProfileInput,
): boolean => BUSINESS_INFO_KEYS.every(key => a[key].trim() === b[key].trim());

export const appendSuggestion = (text: string, suggestion: string): string => {
  const trimmed = text.trimEnd();
  return trimmed ? `${trimmed}\n${suggestion}` : suggestion;
};

export const toProfileTrackingCategory = (
  before: PersonalSurveyProfileInput,
  after: PersonalSurveyProfileInput,
  suggestionApplyCount: number,
): PersonalSurveyProfileTrackingCategory => ({
  additional_business_context_char_count: (
    after.additional_business_context ?? ''
  ).trim().length,
  additional_business_context_suggestion_apply_count: suggestionApplyCount,
  changed_fields: PROFILE_INPUT_KEYS.filter(
    key => (before[key] ?? '').trim() !== (after[key] ?? '').trim(),
  ),
});
